import messagesFr from '../i18n/fr.json';

const frMessages = {
  ...messagesFr,
};

export default frMessages;
